import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var English = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.342 2.25c-2.297-4.994-8.789-.5-11.286 2.197-3.796 4.295-6.792 8.29-10.388 12.785-2.197 3.196-1.498 8.29.5 11.386l-1.598 2.398H8.978c-.4 0-.8.4-.8.799 0 .998 1.2.799 1.798.799 0 .899.1 1.997-.899 2.397C5.582 36.809 5.182 40.304 5.382 44H24.06c.2-3.696-.1-7.092-3.696-8.89-.899-.399-.899-1.597-.899-2.496h.999c.999 0 .999-1.598 0-1.598h-3.096l.998-1.499c3.696.7 8.59-.599 10.787-3.895 2.298-3.895 3.996-7.291 6.193-11.187l-1.398-1.698 2.197.1c1.698-3.296 3.196-6.991 2.197-10.587ZM18.067 32.614c-.1 1.498.3 3.096 1.698 3.895 2.197.999 2.996 3.596 2.796 5.893H7.08c-.5-6.992 4.994-4.495 4.495-9.788h6.492Zm17.279-21.375-2.497-.1h-.1c-.799.1-1.099 1-.699 1.698l.1.1 1.398 1.698c-2.097 3.496-3.596 6.692-5.693 10.188-1.498 2.297-5.793 3.795-8.39 3.196l4.794-7.091c.2-.4.1-.9-.2-1.1-.399-.199-.898-.199-1.098.2l-4.794 7.092-.5-.899c-2.896-6.592 2.098-10.188 5.593-14.782 2.298-2.897 4.595-6.193 7.691-8.29 7.791-4.894 6.692 3.196 4.395 8.09Z"
  }));
});
English.displayName = 'English';
English.defaultProps = {
  'aria-label': 'English'
};
export default English;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/English.js
// module id = 3638
// module chunks = 11